import { SxProps } from '@mui/material';

export const arrowIcon: SxProps = {
  color: 'black !important',
};
